import { render, staticRenderFns } from "./ConfirmDecline.vue?vue&type=template&id=47c480ec&"
import script from "./ConfirmDecline.vue?vue&type=script&lang=js&"
export * from "./ConfirmDecline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports